import NomenclatureListPage from "../../../common/nomenclatures/NomenclatureListPage";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { DefaultInputField } from "../../../common/components/forms/inputs/InputField/DefaultInputField";
import { nameof } from "ts-simple-nameof";
import { NomenclatureListPageBaseItem } from "../../../common/nomenclatures/components/NomenclatureListPageBaseItem";
import {
  eventTypeCategoryDefaults,
  eventTypeCategorySchema,
  IEventTypeCategoryInputModel,
} from "./models/eventTypeCategoryInputModel";

export const EventTypeCategoriesNomenclature = () => {
  return (
    <NomenclatureListPage<
      IEventTypeCategoryInputModel,
      IEventTypeCategoryInputModel
    >
      endpoints={endpointsMetadata.eventTypeCategoryNomenclature}
      title={"Категории за класове"}
      description="Категориите се използват за групиране на класовете при резервация."
      dialogAddTitle="Добавяне на нова категория"
      dialogEditTitle="Редактиране на категория"
      emptyListText={"В момента нямате добавени категории"}
      itemTemplate={(item, index, isLoading, actionButtons, className) => (
        <NomenclatureListPageBaseItem
          item={item}
          isLoading={isLoading}
          actionButtons={actionButtons}
          className={className}
        />
      )}
      formSchema={eventTypeCategorySchema}
      defaultValues={() => eventTypeCategoryDefaults}
      formFields={
        <DefaultInputField
          name={nameof<IEventTypeCategoryInputModel>((x) => x.name)}
          label="Име на категория"
          placeholder={"Йога"}
        />
      }
      editOnRowClick
      showReorderButton
      deletedFilter={{
        storageKey: "eventTypeCategories",
        sectionTitle: "Изтрити категории",
        toggleLabel: "Покажи изтритите категории",
      }}
    />
  );
};
